let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("f9GEs")).then(() => parcelRequire('1cV3d'));